/* ngInject */
export function addTimesToResponse(response, $filter) {
  const videos = response.data.data;
  videos &&
    videos.map(video => {
      const vt = video.video_length;
      if (!vt) return;
      const time = $filter("videoTime")(vt);
      video.videoTime = time;
    });

  return videos;
}



// WEBPACK FOOTER //
// ./~/site_core/src/utils/videoTimes.js